import axios from "axios";
import React, { useEffect, useRef, useState } from "react";
import { FiX } from "react-icons/fi";
import { BACKEND_BASEURL } from "../../db/baseUrl";
import { toast } from "react-toastify";
import Counter from "./Counter";
import dayjs from "dayjs";
import Print from "./print";

const Return = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [isOpenReturn, setIsOpenReturn] = useState(false);
  const [orderNO, setOrderNo] = useState();
  const [order, setOrder] = useState();
  const [updateOrder, setUpdateOrder] = useState();
  const [maxQuantities, setMaxQuantities] = useState({});
  const [orderForReturn, setOrderForReturn] = useState();
  // const [returnItem, setReturnItem] = useState();
  const [isSuccess, setIsSuccess] = useState(false);
  const [returnAmount, setReturnAmount] = useState();

  const handleClose = () => {
    setIsOpen(false);
  };

  const handleKeyDown = (event) => {
    if (event.key === "Shift") {
      handleOpen();
    }
  };

  useEffect(() => {
    window.addEventListener("keydown", handleKeyDown);
    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, []);

  const priceSymbol = process.env.REACT_APP_PRICE_SYMBOL;

  const getOrderByOrderNo = async (orderNO) => {
    if (!orderNO) {
      toast.error("Order No is required");
      return;
    }
    try {
      const response = await axios.get(
        `${BACKEND_BASEURL}api/orders/getOrderByOrderNo/${orderNO}`
      );
      const fetchedData = response.data.data;
      setOrder(fetchedData);
      setOrderForReturn(fetchedData.products);
      const initialMaxQuantities = fetchedData.products.reduce(
        (acc, product) => {
          acc[product.productId] = product.quantity;
          return acc;
        },
        {}
      );
      setMaxQuantities(initialMaxQuantities);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        "An unexpected error occurred";
      toast.error(message);
    }
  };

  const totalOrderAmount = order?.products?.reduce(
    (total, item) => total + item.quantity * item.price,
    0
  );

  const updateAndReturnOrder = async (updateOrderAndReturn) => {
    try {
      const response = await axios.post(
        `${BACKEND_BASEURL}api/orders/returnOrder`,
        { updateOrderAndReturn }
      );
      const fetchedData = response;
      toast.success(response.data.message);
      setUpdateOrder(response.data.order);
      setReturnAmount(response.data.returnOrder);
      setIsSuccess(true);
      console.log(fetchedData);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        "An unexpected error occurred";
      console.log(message);
    }
  };

  const handleSubmit = async () => {
    let currentOrder = order.products;
    const filteredItems = await orderForReturn
      .map((originalItem) => {
        const modifiedItem = currentOrder.find(
          (item) => item.productId === originalItem.productId
        );

        if (modifiedItem) {
          const remainingQuantity =
            originalItem.quantity - modifiedItem.quantity;
          if (
            remainingQuantity > 0 ||
            originalItem.price !== modifiedItem.price ||
            originalItem.cost !== modifiedItem.cost ||
            originalItem.tax !== modifiedItem.tax
          ) {
            return {
              ...originalItem,
              quantity: remainingQuantity > 0 ? remainingQuantity : 0,
            };
          }

          return null;
        }
        return originalItem;
      })
      .filter(Boolean);

    // await setReturnItem(filteredItems);

    const updatedOrder = {
      ...order,
      totalAmount: totalOrderAmount,
      totalAmountDiscount:
        totalOrderAmount > order.totalAmountDiscount
          ? order.totalAmountDiscount
          : 0,
      totalAmountAfterDiscount:
        order?.totalAmountDiscount > 0 &&
        order.totalAmountDiscount < totalOrderAmount
          ? totalOrderAmount - order?.totalAmountDiscount
          : totalOrderAmount,
      returnAmount:
        order.paidAmount -
        (order.totalAmountDiscount > 0 &&
        order.totalAmountDiscount < totalOrderAmount
          ? totalOrderAmount - order.totalAmountDiscount
          : totalOrderAmount),
    };
    const totalReturnOrderAmount = filteredItems.reduce(
      (total, item) => total + item.quantity * item.price,
      0
    );

    const updateOrderAndReturn = {
      updatedOrder,
      returnOrder: filteredItems,
      returnAmount:
        updatedOrder?.products?.length === 0
          ? order.totalAmountDiscount > 0
            ? totalReturnOrderAmount - order.totalAmountDiscount
            : totalReturnOrderAmount
          : totalReturnOrderAmount,
      orderNO: updatedOrder.orderNO,
    };
    if (updateOrderAndReturn.returnOrder?.length > 0) {
      updateAndReturnOrder(updateOrderAndReturn);
    } else {
      toast.error("Return Order is empty");
    }
  };

  const handleQuantityChange = (id, newQuantity) => {
    const updatedOrder = {
      ...order,
      products: order.products
        .map((item) =>
          item.productId === id ? { ...item, quantity: newQuantity } : item
        )
        .filter((item) => item.quantity > 0),
    };
    setOrder(updatedOrder);
  };

  const printRef = useRef();

  const handlePrint = () => {
    const printContent = printRef.current;
    const originalContent = document.body.innerHTML;

    document.body.innerHTML = printContent.innerHTML;
    window.print();
    document.body.innerHTML = originalContent;

    window.location.reload();
  };

  useEffect(() => {
    if (isSuccess) {
      setOrder();
      setOrderNo();
      setIsOpen(false);
      setIsOpenReturn(true);
      setTimeout(() => {
        setIsOpenReturn(false);
        handlePrint();
        setIsSuccess(false);
      }, 1500);
    }
  }, [isSuccess]);

  const handleOpen = () => setIsOpen(true);
  return (
    <div>
      <button
        onClick={handleOpen}
        className="w-[84%] lg:p-3 p-1.5 lg:text-[1rem] text-[.9rem]  rounded-xl  bg-[#d64d23] text-white font-semibold outline-none"
      >
        Return
      </button>
      {isOpen && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
          <div className="bg-white shadow-xl rounded-[10px]  lg:w-[50%] md:w-[70%] w-[90%] h-[80vh] overflow-y-auto scrollbar-hide  mx-auto p-5 pt-0 space-y-6 relative">
            <div className=" sticky top-0 bg-white z-10 pt-5">
              <div className="flex justify-between items-center border-b-2 border-[#DEDEDE] pb-2 mb-4">
                <h1 className="lg:text-[1.2rem] text-[1rem] font-bold text-[#0D868C]">
                  Return
                </h1>
                <button type="button" onClick={handleClose}>
                  <FiX className=" size-6 text-[#0D868C]" />
                </button>
              </div>
              <div className="flex w-full items-end justify-center gap-2">
                <div className="flex flex-col flex-1">
                  <label
                    htmlFor=""
                    className="lg:text-[.75rem] text-[.65rem] font-semibold text-[#7D7D7D] leading-none"
                  >
                    Receipt No
                  </label>

                  <input
                    type="number"
                    value={orderNO}
                    onChange={(e) => setOrderNo(e.target.value)}
                    placeholder="844783 etc."
                    className=" bg-transparent outline-none border-b lg:pt-3 pt-1.5 border-[#0d868c]"
                  />
                </div>
                <div>
                  <p
                    onClick={() => getOrderByOrderNo(orderNO)}
                    className="bg-[#0D868C] cursor-pointer  rounded-full lg:p-2.5 p-[10px] capitalize font-semibold text-white"
                  >
                    get order
                  </p>
                </div>
              </div>
            </div>
            <div>
              {order && (
                <>
                  <p className="mb-2">
                    Date: {dayjs(order?.createdAt).format("D /M /YYYY ")}
                  </p>
                  <div className=" w-full overflow-auto scrollbar-hide touch-auto border-none bg-white h-full pb-2 rounded-t-lg ">
                    <table className="w-[100%]   ">
                      <thead className="bg-[#f5f4f4] lg:text-[1rem] text-[.9rem] capitalize sticky top-0 ">
                        <tr>
                          <th
                            className="p-3 font-bold tracking-wide text-center w-[5%]"
                            scope="col"
                          >
                            id
                          </th>
                          <th
                            className="p-3 font-bold tracking-wide text-start w-[50%]"
                            scope="col"
                          >
                            name
                          </th>
                          <th
                            className="p-3 font-bold tracking-wide text-center w-[15%]"
                            scope="col"
                          >
                            quantity
                          </th>
                          <th
                            className="p-3 font-bold tracking-wide text-center w-[10%]"
                            scope="col"
                          >
                            tax
                          </th>
                          <th
                            className="p-3 font-bold tracking-wide text-center  w-[10%]"
                            scope="col"
                          >
                            rate
                          </th>
                          <th
                            className="p-3 font-bold tracking-wide text-center  w-[10%]"
                            scope="col"
                          >
                            amount
                          </th>
                        </tr>
                      </thead>
                      <tbody className="  overflow-y-auto ">
                        {order?.products?.map((item) => (
                          <tr
                            key={item.productId}
                            className="border-b last:border-none mx-2"
                          >
                            <td
                              className={`p-3  lg:text-sm text-[12px] text-gray-700 whitespace-nowrap text-center   `}
                            >
                              {item.productId}
                            </td>
                            <td
                              className={`p-3  lg:text-sm text-[12px] text-gray-700 whitespace-nowrap text-start   `}
                            >
                              {item.name}
                            </td>

                            <td
                              className={`p-3 lg:text-sm text-[12px] text-gray-700 whitespace-nowrap text-center   `}
                            >
                              <Counter
                                quantity={item.quantity}
                                onQuantityChange={(newQuantity) =>
                                  handleQuantityChange(
                                    item.productId,
                                    newQuantity
                                  )
                                }
                                max={maxQuantities[item.productId]}
                              />
                            </td>
                            <td
                              className={`p-3 lg:text-sm text-[12px] text-gray-700 whitespace-nowrap text-center   `}
                            >
                              {item.tax}%
                            </td>
                            <td
                              className={`p-3 lg:text-sm text-[12px] text-gray-700 whitespace-nowrap text-center   `}
                            >
                              {item.price}
                            </td>

                            <td className="p-3 lg:text-sm text-[12px] text-gray-700 whitespace-nowrap text-center">
                              {item.price * item.quantity}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                  <div>
                    <div>
                      <p className="flex flex-col ml-auto lg:w-[60%] w-[80%] lg:p-4 p-3 lg:text-[1rem] text-[.8rem] ">
                        {order?.totalAmountDiscount > 0 &&
                        order.totalAmountDiscount < totalOrderAmount ? (
                          <div className="flex justify-between items-center w-full">
                            <span className="text-[#1E1E1E] font-bold">
                              Total
                            </span>
                            <span className="text-[#1E1E1E] flex gap-3 items-center ">
                              <span className=" line-through text-[#1E1E1E]">
                                {priceSymbol} {totalOrderAmount.toFixed(2)}
                              </span>
                              {priceSymbol}{" "}
                              {(
                                totalOrderAmount - order?.totalAmountDiscount
                              ).toFixed(2)}
                            </span>
                          </div>
                        ) : (
                          <div className="flex justify-between items-center w-full">
                            <span className="text-[#1E1E1E] font-bold">
                              Total
                            </span>
                            <span className="text-[#1E1E1E]">
                              {priceSymbol} {totalOrderAmount.toFixed(2)}
                            </span>
                          </div>
                        )}
                        {order?.paidAmount > 0 && (
                          <div className="flex flex-col w-full text-[.8rem]">
                            <div className="flex justify-between items-center w-full">
                              <span className="text-[#1E1E1E] font-bold capitalize">
                                {order?.amountType}
                              </span>
                              <span className="text-[#1E1E1E]">
                                {priceSymbol} {order?.paidAmount.toFixed(2)}
                              </span>
                            </div>
                            {order?.totalAmountDiscount > 0 &&
                            order.totalAmountDiscount < totalOrderAmount ? (
                              <div className="flex justify-between items-center w-full">
                                <span className="text-[#1E1E1E] font-bold">
                                  Paid
                                </span>
                                <span className="text-[#1E1E1E] flex gap-3 items-center ">
                                  {priceSymbol}{" "}
                                  {(
                                    totalOrderAmount -
                                    order?.totalAmountDiscount
                                  ).toFixed(2)}
                                </span>
                              </div>
                            ) : (
                              <div className="flex justify-between items-center w-full">
                                <span className="text-[#1E1E1E] font-bold">
                                  Paid
                                </span>
                                <span className="text-[#1E1E1E]">
                                  {priceSymbol} {totalOrderAmount.toFixed(2)}
                                </span>
                              </div>
                            )}

                            <div className="flex justify-between items-center w-full">
                              <span className="text-[#1E1E1E] font-bold">
                                Change
                              </span>
                              <span className="text-[#1E1E1E]">
                                {priceSymbol}{" "}
                                {order.paidAmount -
                                  (order.totalAmountDiscount > 0 &&
                                  order.totalAmountDiscount < totalOrderAmount
                                    ? totalOrderAmount -
                                      order.totalAmountDiscount
                                    : totalOrderAmount
                                  ).toFixed(2)}
                              </span>
                            </div>
                          </div>
                        )}
                      </p>
                    </div>
                  </div>
                </>
              )}
            </div>
            {order && (
              <div className=" absolute bottom-4">
                <button
                  onClick={handleSubmit}
                  className="bg-[#0D868C] cursor-pointer  rounded-full lg:py-2.5 py-[10px] px-4 capitalize font-semibold text-white"
                >
                  submit
                </button>
              </div>
            )}
          </div>
        </div>
      )}
      {isOpenReturn && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
          <div className="bg-white shadow-xl rounded-[10px] w-max  mx-auto p-5 text-center relative">
            <FiX
              className=" absolute top-2 right-2 "
              onClick={(e) => setIsOpenReturn(false)}
            />
            <p className=" font-semibold capitalize">
              Amount Return to Customer
            </p>
            <p className="text-black font-bold text-[1.5rem]">
              {priceSymbol} {returnAmount.returnAmount.toFixed(2)}
            </p>
          </div>
        </div>
      )}
      <Print currentOrder={updateOrder} printRef={printRef} />
    </div>
  );
};

export default Return;
